module.exports = __webpack_public_path__ + "static/media/down-triangle.301584c8.svg";